import React, { memo, Fragment } from "react";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { AvailableCorporationInsuranceFilters } from '../form/AvailableCorporationInsuranceFilters';

export const EditAcceptanceResult = memo((props) => {
  const { init_acceptance_result, removeAcceptanceResult } = props;

  const notify = (type, message) => {
    if (type === "success") {
      toast.success(message, {
        hideProgressBar: true
      });
    } else {
      toast.error(message, {
        hideProgressBar: true
      });
    }
  }

  const onClickDeleteSubmit = (id) => {
    const sure = window.confirm('Are you sure?');
    if (sure) {
      // axios csrfToken
      const csrfToken = document.querySelector('[name=csrf-token]').content
      axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

      axios.delete(`/api/v1/acceptance_results/${id}`)
      .then(resp => {
        console.log(resp);
        removeAcceptanceResult(id);
        notify("success", "AcceptanceResult successfully deleted!");
      })
      .catch(e => {
        console.log(e.response);
        notify("error", "AcceptanceResult delete Error!");
      })
    }
  }

  return (
    <>
      <tr>
        <th scope="row" className="col">{init_acceptance_result.corporation_name}</th>
        <td className="col-1">
          <button className="btn btn-outline-danger" onClick={() => onClickDeleteSubmit(init_acceptance_result.id)}>
            <i className="far fa-trash-alt" />
          </button>
        </td>
        {init_acceptance_result.insurances.length > 0 ?
          <td className="col-6">
            <AvailableCorporationInsuranceFilters
              acceptance_result_id={init_acceptance_result.id}
              insurances={init_acceptance_result.insurances}
              using_insurance_ids={init_acceptance_result.using_insurance_ids} />
            </td>
        :
          <td className="col-6">現在、企業マスタに連携された健保がありません。</td>
        }
      </tr>
    </>
  );
});